 jQuery(window).scroll(function(){
      if (jQuery(this).scrollTop() > 120) {
          jQuery('.header-wrapper').addClass('fixed');
      } else {
          jQuery('.header-wrapper').removeClass('fixed');
      }
});









